import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type {
	Invoice,
	InvoiceListParams,
	InvoiceListResponse,
	SendInvoiceRequest,
} from '../types/invoice';

export const invoiceApi = {
	getList: async (params: InvoiceListParams = {}): Promise<InvoiceListResponse> => {
		const qs = new URLSearchParams();
		if (params.locationId != null) qs.set('locationId', String(params.locationId));
		if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
		if (params.dateTo) qs.set('dateTo', params.dateTo);
		if (params.status) qs.set('status', params.status);
		if (params.search) qs.set('search', params.search);
		if (params.page != null) qs.set('page', String(params.page));
		if (params.size != null) qs.set('size', String(params.size));
		const query = qs.toString();
		return apiClient.get<InvoiceListResponse>(
			`${API_ENDPOINTS.INVOICE.LIST}${query ? `?${query}` : ''}`
		);
	},

	getDetail: async (id: number): Promise<Invoice> => {
		return apiClient.get<Invoice>(API_ENDPOINTS.INVOICE.DETAIL(id));
	},

	send: async (data: SendInvoiceRequest): Promise<void> => {
		return apiClient.post(API_ENDPOINTS.INVOICE.SEND, data);
	},
};
